import React, { useMemo } from 'react';
import './spin-edit-reskin.scss';

/* onModified(newValue, isManualEdit) // optional
 *  Function will be called when control value changes, with
 *  parameters newValue and isManualEdit, which are the
 *  new control value, and a boolean that is true if the user
 *  edited the value without using the plus and minus buttons.
 */
export default function SpinEditReskin({ disabled, ...props }) {
  const lightMode = !!props.lightMode;

  const normalizeValue = (value) => {
    let newValue = value ? parseInt(value) : 0;
    if (props.min && props.min > newValue) {
      newValue = props.min;
    }
    if (props.max && props.max < newValue) {
      newValue = props.max;
    }
    return newValue;
  };

  const valueMemo = useMemo(
    () => normalizeValue(props?.field?.value || props.value),
    [props?.field?.value, props.value],
  );

  const setValue = (value) => {
    if (props.onModified) {
      props.onModified(normalizeValue(value));
    } else {
      props.form.setFieldValue(props.field.name, normalizeValue(value));
    }
  };

  const increaseValue = async () => {
    if (props.max === undefined || valueMemo < props.max) {
      setValue(valueMemo + 1);
    }
  };

  const decreaseValue = async () => {
    if (props.min === undefined || valueMemo > props.min) {
      setValue(valueMemo - 1);
    }
  };

  const isValueEqualToMax = props.max !== undefined ? valueMemo === props.max : false;
  const isValueEqualToMin = props.min !== undefined ? valueMemo === props.min : false;

  return (
    <div className={`spin-edit-reskin ${props.className}`}>
      {props.label && <span className="input-section">{props.label}</span>}
      <div className="input-section">
        <span
          onClick={!disabled ? decreaseValue : null}
          className={`icon-minus-utility reskin ${lightMode ? 'dark' : ''} ${
            disabled || isValueEqualToMin ? 'invisible' : ''
          }`}
          automationid={`${props.automationid}_Minus`}
        />
        <div className="number-input-container">
          <input
            type="number"
            onChange={(event) => {
              if (disabled) {
                return;
              }
              event.preventDefault();
              const valueNew = event.target.value;

              const regex = /^$|^[0-9\b]+$/;
              if (!valueNew || regex.test(valueNew.toString())) {
                props.field.onChange(event);
                setValue(valueNew);
              }
            }}
            onFocus={props.onFocus}
            onBlur={() => {
              if (disabled) {
                return;
              }
              if (props.onBlur) {
                props.onBlur();
              }
            }}
            name={props.field.name}
            maxLength="2"
            className={`input number-input ${lightMode ? 'dark' : ''} ${
              disabled ? 'disabled' : ''
            }`}
            value={valueMemo}
            automationid={`${props.automationid}_Value`}
            disabled={disabled}
          />
        </div>
        <span
          onClick={!disabled ? increaseValue : null}
          automationid={`${props.automationid}_Plus`}
          className={`icon-add-utility reskin ${lightMode ? 'dark' : ''} ${
            disabled || isValueEqualToMax ? 'invisible' : ''
          }`}
        />
      </div>
    </div>
  );
}
